import { defineComponent, ref, computed, openBlock, createElementBlock, normalizeClass, renderSlot } from 'vue';

var InlineInputBoxSize;
(function (InlineInputBoxSize) {
  InlineInputBoxSize["L"] = "l";
  InlineInputBoxSize["M"] = "m";
  InlineInputBoxSize["S"] = "s";
})(InlineInputBoxSize || (InlineInputBoxSize = {}));

const InlineInputBox = [
// Layout
'layout-row',
// Box
'w-full', 'box-border',
// Shape
'rounded-sm',
// Theme
// Border
'border-solid', 'border-1', 'border-transparent', 'enabled:valid:focus-within:border-primary', 'enabled:valid:focus-within:dark:border-primary-dark', 'enabled:invalid:focus-within:border-error', 'enabled:invalid:focus-within:dark:border-error-dark',
// Outline
'enabled:outline-none', 'enabled:outline-2', 'enabled:outline-offset-0', 'enabled:valid:focus-within:outline-primary-opacity-0-16', 'enabled:valid:focus-within:dark:outline-primary-opacity-0-16-dark', 'enabled:invalid:focus-within:outline-error-opacity-0-16', 'enabled:invalid:focus-within:dark:outline-error-opacity-0-16-dark',
// Background
'enabled:valid:hover:bg-primary-opacity-0-08', 'enabled:valid:hover:dark:bg-primary-opacity-0-08-dark',
// 'enabled:valid:focus-within:bg-primary-opacity-0-08',
// 'enabled:valid:focus-within:dark:bg-primary-opacity-0-08-dark',
'enabled:valid:activated:bg-primary-opacity-0-08', 'enabled:valid:activated:dark:bg-primary-opacity-0-08-dark', 'enabled:invalid:bg-error-opacity-0-08', 'enabled:invalid:dark:bg-error-opacity-0-08-dark',
// Text
'enabled:valid:text-on-background', 'enabled:valid:dark:text-on-background-dark', 'enabled:valid:focus-within:text-on-background', 'enabled:valid:focus-within:dark:text-on-background-dark', 'enabled:invalid:focus-within:text-on-background', 'enabled:invalid:focus-within:dark:text-on-background-dark', 'disabled:text-on-disabled', 'disabled:dark:text-on-disabled-dark'];
const InlineInputBoxSizes = {
  [InlineInputBoxSize.L]: [
  // Spacing
  'children:py-xs*', 'activated:children:px-sm', 'gap-md',
  // Typography
  'typography-headline-2'],
  [InlineInputBoxSize.M]: [
  // Spacing
  'children:py-xs*', 'activated:children:px-sm', 'gap-md',
  // Typography
  'typography-body-2-regular'],
  [InlineInputBoxSize.S]: [
  // Spacing
  'activated:children:px-xs', 'children:py-0', 'gap-md',
  // Typography
  'typography-body-2-regular', 'leading-[23px] md:leading-[19px]']
};

var script = defineComponent({
  name: 'OrInlineInputBox',
  props: {
    size: {
      type: String,
      default: () => InlineInputBoxSize.M
    },
    invalid: {
      type: Boolean,
      default: false
    },
    activated: {
      type: Boolean,
      default: false
    }
  },
  expose: ['root'],
  setup(props) {
    // Refs
    const root = ref();
    // Styles
    const rootStyles = computed(() => ['or-inline-input-box-v3', ...InlineInputBox, ...InlineInputBoxSizes[props.size]]);
    return {
      root,
      rootStyles
    };
  }
});

const _hoisted_1 = ["invalid", "activated"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(_ctx.rootStyles),
    invalid: _ctx.invalid,
    activated: _ctx.activated
  }, [renderSlot(_ctx.$slots, "default")], 10 /* CLASS, PROPS */, _hoisted_1);
}

script.render = render;
script.__file = "src/components/or-inline-input-box-v3/OrInlineInputBox.vue";

export { InlineInputBoxSize, script as OrInlineInputBoxV3 };
